/* eslint-disable max-len */
import {
  ABOUT_LANGUAGE_PATH,
  AMENITIES_LANGUAGE_PATH,
  CONTENT_KEY,
  LOCATION_LANGUAGE_PATH,
  NEWS_LANGUAGE_PATH,
  SITEPLAN_LANGUAGE_PATH,
} from './enums';
import { RedirectLinkTypes } from '../../types';

// home page
export const HOME_PAGE_LINK = '/:projectKey';
export const MODULE_PAGE_LINK = `${HOME_PAGE_LINK}/:activeKey`;
export const DETAIL_PAGE_LINK = '/:activeKey/:projectKey/:itemKey';
// about
export const EN_ABOUT_PAGE_LINK = `${HOME_PAGE_LINK}/${ABOUT_LANGUAGE_PATH.EN}`;
export const VI_ABOUT_PAGE_LINK = `${HOME_PAGE_LINK}/${ABOUT_LANGUAGE_PATH.VI}`;
export const JP_ABOUT_PAGE_LINK = `${HOME_PAGE_LINK}/${ABOUT_LANGUAGE_PATH.JP}`;
// location
export const EN_LOCATION_PAGE_LINK = `${HOME_PAGE_LINK}/${LOCATION_LANGUAGE_PATH.EN}`;
export const VI_LOCATION_PAGE_LINK = `${HOME_PAGE_LINK}/${LOCATION_LANGUAGE_PATH.VI}`;
export const JP_LOCATION_PAGE_LINK = `${HOME_PAGE_LINK}/${LOCATION_LANGUAGE_PATH.JP}`;
// amenities
export const EN_AMENITIES_PAGE_LINK = `${HOME_PAGE_LINK}/${AMENITIES_LANGUAGE_PATH.EN}`;
export const VI_AMENITIES_PAGE_LINK = `${HOME_PAGE_LINK}/${AMENITIES_LANGUAGE_PATH.VI}`;
export const JP_AMENITIES_PAGE_LINK = `${HOME_PAGE_LINK}/${AMENITIES_LANGUAGE_PATH.JP}`;
// site-plan
export const EN_SITE_PLAN_PAGE_LINK = `${HOME_PAGE_LINK}/${SITEPLAN_LANGUAGE_PATH.EN}`;
export const VI_SITE_PLAN_PAGE_LINK = `${HOME_PAGE_LINK}/${SITEPLAN_LANGUAGE_PATH.VI}`;
export const JP_SITE_PLAN_PAGE_LINK = `${HOME_PAGE_LINK}/${SITEPLAN_LANGUAGE_PATH.JP}`;
export const SITE_PLAN_DETAIL_PAGE_LINK = '/:languagePath/:projectKey/:itemKey';
export const EN_SITE_PLAN_DETAIL_PAGE_LINK = `/${SITEPLAN_LANGUAGE_PATH.EN}/:projectKey/:itemKey`;
export const VI_SITE_PLAN_DETAIL_PAGE_LINK = `/${SITEPLAN_LANGUAGE_PATH.VI}/:projectKey/:itemKey`;
export const JP_SITE_PLAN_DETAIL_PAGE_LINK = `/${SITEPLAN_LANGUAGE_PATH.JP}/:projectKey/:itemKey`;
export const SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK =
  '/:languagePath/:projectKey/:itemKey/:extendable';
export const EN_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK = `/${SITEPLAN_LANGUAGE_PATH.EN}/:projectKey/:itemKey/:extendable`;
export const VI_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK = `/${SITEPLAN_LANGUAGE_PATH.VI}/:projectKey/:itemKey/:extendable`;
export const JP_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK = `/${SITEPLAN_LANGUAGE_PATH.JP}/:projectKey/:itemKey/:extendable`;
// news
export const EN_NEWS_PAGE_LINK = `${HOME_PAGE_LINK}/${NEWS_LANGUAGE_PATH.EN}`;
export const VI_NEWS_PAGE_LINK = `${HOME_PAGE_LINK}/${NEWS_LANGUAGE_PATH.VI}`;
export const JP_NEWS_PAGE_LINK = `${HOME_PAGE_LINK}/${NEWS_LANGUAGE_PATH.JP}`;
export const NEWS_DETAIL_PAGE_LINK = '/:languagePath/:projectKey/:itemKey';
export const EN_NEWS_DETAIL_PAGE_LINK = `/${NEWS_LANGUAGE_PATH.EN}/:projectKey/:itemKey`;
export const VI_NEWS_DETAIL_PAGE_LINK = `/${NEWS_LANGUAGE_PATH.VI}/:projectKey/:itemKey`;
export const JP_NEWS_DETAIL_PAGE_LINK = `/${NEWS_LANGUAGE_PATH.JP}/:projectKey/:itemKey`;
// home profile
export const HOME_PROFILE_PAGE_LINK = `${HOME_PAGE_LINK}/:itemKey/:extendable`;
// home profile / add on
export const HOME_PROFILE_ADD_ON_PAGE_LINK = `${HOME_PAGE_LINK}/:itemKey/:extendable/:addOnKey`;
// self-home-profile page root
export const SELF_HOME_PROFILE_PAGE_LINK = '/:languagePath/:itemKey';
// self-home-profile / add on
export const SELF_HOME_PROFILE_ADD_ON_PAGE_LINK = '/:languagePath/:itemKey/:addOnKey';

/* start EN */
// self-home-profile page root
export const EN_SELF_HOME_PROFILE_PAGE_LINK = '/homeprofile/:itemKey';
// self-home-profile / add on
export const EN_SELF_HOME_PROFILE_ADD_ON_PAGE_LINK = '/homeprofile/:itemKey/:addOnKey';
// content path root
export const CONTENT_PATH_EN_ROOT_PAGE_LINK = `${process.env.REACT_APP_CONTEXT_PATH_EN}`;
// content path page
export const CONTENT_PATH_EN_HOME_PAGE_LINK = `${CONTENT_PATH_EN_ROOT_PAGE_LINK}${HOME_PAGE_LINK}`;
// content path module page / about
export const CONTENT_PATH_EN_MODULE_ABOUT_PAGE_LINK = `${CONTENT_PATH_EN_ROOT_PAGE_LINK}${EN_ABOUT_PAGE_LINK}`;
// content path module page / location
export const CONTENT_PATH_EN_MODULE_LOCATION_PAGE_LINK = `${CONTENT_PATH_EN_ROOT_PAGE_LINK}${EN_LOCATION_PAGE_LINK}`;
// content path module page / amenities
export const CONTENT_PATH_EN_MODULE_AMENITIES_PAGE_LINK = `${CONTENT_PATH_EN_ROOT_PAGE_LINK}${EN_AMENITIES_PAGE_LINK}`;
// content path module page / site-plan
export const CONTENT_PATH_EN_MODULE_SITE_PLAN_PAGE_LINK = `${CONTENT_PATH_EN_ROOT_PAGE_LINK}${EN_SITE_PLAN_PAGE_LINK}`;
export const CONTENT_PATH_EN_MODULE_SITE_PLAN_DETAIL_PAGE_LINK = `${CONTENT_PATH_EN_ROOT_PAGE_LINK}${EN_SITE_PLAN_DETAIL_PAGE_LINK}`;
export const CONTENT_PATH_EN_MODULE_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK = `${CONTENT_PATH_EN_ROOT_PAGE_LINK}${EN_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK}`;
// content path page / news
export const CONTENT_PATH_EN_NEWS_PAGE_LINK = `${CONTENT_PATH_EN_ROOT_PAGE_LINK}${EN_NEWS_PAGE_LINK}`;
export const CONTENT_PATH_EN_NEWS_DETAIL_PAGE_LINK = `${CONTENT_PATH_EN_ROOT_PAGE_LINK}${EN_NEWS_DETAIL_PAGE_LINK}`;
// content path page / home profile
export const CONTENT_PATH_EN_HOME_PROFILE_PAGE_LINK = `${CONTENT_PATH_EN_ROOT_PAGE_LINK}${HOME_PROFILE_PAGE_LINK}`;
// content path page / home profile / add on
export const CONTENT_PATH_EN_HOME_PROFILE_ADD_ON_PAGE_LINK = `${CONTENT_PATH_EN_ROOT_PAGE_LINK}${HOME_PROFILE_ADD_ON_PAGE_LINK}`;
/* end EN */

/* start JP */
// self-home-profile page root
export const JP_SELF_HOME_PROFILE_PAGE_LINK = '/homeprofile-jp/:itemKey';
// self-home-profile / add on
export const JP_SELF_HOME_PROFILE_ADD_ON_PAGE_LINK = '/homeprofile-jp/:itemKey/:addOnKey';
// content path root
export const CONTENT_PATH_JP_ROOT_PAGE_LINK = `${process.env.REACT_APP_CONTEXT_PATH_JP}`;
// content path page
export const CONTENT_PATH_JP_HOME_PAGE_LINK = `${CONTENT_PATH_JP_ROOT_PAGE_LINK}${HOME_PAGE_LINK}`;
// content path module page / about
export const CONTENT_PATH_JP_MODULE_ABOUT_PAGE_LINK = `${CONTENT_PATH_JP_ROOT_PAGE_LINK}${JP_ABOUT_PAGE_LINK}`;
// content path module page / location
export const CONTENT_PATH_JP_MODULE_LOCATION_PAGE_LINK = `${CONTENT_PATH_JP_ROOT_PAGE_LINK}${JP_LOCATION_PAGE_LINK}`;
// content path module page / amenities
export const CONTENT_PATH_JP_MODULE_AMENITIES_PAGE_LINK = `${CONTENT_PATH_JP_ROOT_PAGE_LINK}${JP_AMENITIES_PAGE_LINK}`;
// content path module page / site-plan
export const CONTENT_PATH_JP_MODULE_SITE_PLAN_PAGE_LINK = `${CONTENT_PATH_JP_ROOT_PAGE_LINK}${JP_SITE_PLAN_PAGE_LINK}`;
export const CONTENT_PATH_JP_MODULE_SITE_PLAN_DETAIL_PAGE_LINK = `${CONTENT_PATH_JP_ROOT_PAGE_LINK}${JP_SITE_PLAN_DETAIL_PAGE_LINK}`;
export const CONTENT_PATH_JP_MODULE_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK = `${CONTENT_PATH_JP_ROOT_PAGE_LINK}${JP_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK}`;
// content path page / news
export const CONTENT_PATH_JP_NEWS_PAGE_LINK = `${CONTENT_PATH_JP_ROOT_PAGE_LINK}${JP_NEWS_PAGE_LINK}`;
export const CONTENT_PATH_JP_NEWS_DETAIL_PAGE_LINK = `${CONTENT_PATH_JP_ROOT_PAGE_LINK}${JP_NEWS_DETAIL_PAGE_LINK}`;
// content path page / home profile
export const CONTENT_PATH_JP_HOME_PROFILE_PAGE_LINK = `${CONTENT_PATH_JP_ROOT_PAGE_LINK}${HOME_PROFILE_PAGE_LINK}`;
// content path page / home profile / add on
export const CONTENT_PATH_JP_HOME_PROFILE_ADD_ON_PAGE_LINK = `${CONTENT_PATH_JP_ROOT_PAGE_LINK}${HOME_PROFILE_ADD_ON_PAGE_LINK}`;
/* end JP */

/* start VI */
// self-home-profile page root
export const VI_SELF_HOME_PROFILE_PAGE_LINK = '/can-ho/:itemKey';
// self-home-profile / add on
export const VI_SELF_HOME_PROFILE_ADD_ON_PAGE_LINK = '/can-ho/:itemKey/:addOnKey';
// content path root
export const CONTENT_PATH_VI_ROOT_PAGE_LINK = `${process.env.REACT_APP_CONTEXT_PATH_VI}`;
// content path page
export const CONTENT_PATH_VI_HOME_PAGE_LINK = `${CONTENT_PATH_VI_ROOT_PAGE_LINK}${HOME_PAGE_LINK}`;
// content path module page / about
export const CONTENT_PATH_VI_MODULE_ABOUT_PAGE_LINK = `${CONTENT_PATH_VI_ROOT_PAGE_LINK}${VI_ABOUT_PAGE_LINK}`;
// content path module page / location
export const CONTENT_PATH_VI_MODULE_LOCATION_PAGE_LINK = `${CONTENT_PATH_VI_ROOT_PAGE_LINK}${VI_LOCATION_PAGE_LINK}`;
// content path module page / amenities
export const CONTENT_PATH_VI_MODULE_AMENITIES_PAGE_LINK = `${CONTENT_PATH_VI_ROOT_PAGE_LINK}${VI_AMENITIES_PAGE_LINK}`;
// content path module page / site-plan
export const CONTENT_PATH_VI_MODULE_SITE_PLAN_PAGE_LINK = `${CONTENT_PATH_VI_ROOT_PAGE_LINK}${VI_SITE_PLAN_PAGE_LINK}`;
export const CONTENT_PATH_VI_MODULE_SITE_PLAN_DETAIL_PAGE_LINK = `${CONTENT_PATH_VI_ROOT_PAGE_LINK}${VI_SITE_PLAN_DETAIL_PAGE_LINK}`;
export const CONTENT_PATH_VI_MODULE_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK = `${CONTENT_PATH_VI_ROOT_PAGE_LINK}${VI_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK}`;
// content path page / news
export const CONTENT_PATH_VI_NEWS_PAGE_LINK = `${CONTENT_PATH_VI_ROOT_PAGE_LINK}${VI_NEWS_PAGE_LINK}`;
export const CONTENT_PATH_VI_NEWS_DETAIL_PAGE_LINK = `${CONTENT_PATH_VI_ROOT_PAGE_LINK}${VI_NEWS_DETAIL_PAGE_LINK}`;
// content path page / home profile
export const CONTENT_PATH_VI_HOME_PROFILE_PAGE_LINK = `${CONTENT_PATH_VI_ROOT_PAGE_LINK}${HOME_PROFILE_PAGE_LINK}`;
// content path page / home profile / add on
export const CONTENT_PATH_VI_HOME_PROFILE_ADD_ON_PAGE_LINK = `${CONTENT_PATH_VI_ROOT_PAGE_LINK}${HOME_PROFILE_ADD_ON_PAGE_LINK}`;
/* end VI */

// default page
export const NOT_FOUND_PAGE_LINK = '/404';
export const NOT_AVAILABLE_PAGE_LINK = '/not-available';

export const REDIRECT_LINK: RedirectLinkTypes[] = [
  // context path routers
  {
    from: `${CONTENT_PATH_VI_ROOT_PAGE_LINK}/about/:projectKey`,
    to: CONTENT_PATH_VI_MODULE_ABOUT_PAGE_LINK,
  },
  {
    from: `${CONTENT_PATH_VI_ROOT_PAGE_LINK}/location/:projectKey`,
    to: CONTENT_PATH_VI_MODULE_LOCATION_PAGE_LINK,
  },
  {
    from: `${CONTENT_PATH_VI_ROOT_PAGE_LINK}/amenities/:projectKey`,
    to: CONTENT_PATH_VI_MODULE_AMENITIES_PAGE_LINK,
  },
  {
    from: `${CONTENT_PATH_VI_ROOT_PAGE_LINK}/site-plan/:projectKey/:itemKey/:extendable`,
    to: CONTENT_PATH_VI_MODULE_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK,
  },
  {
    from: `${CONTENT_PATH_VI_ROOT_PAGE_LINK}/site-plan/:projectKey/:itemKey`,
    to: CONTENT_PATH_VI_MODULE_SITE_PLAN_DETAIL_PAGE_LINK,
  },
  {
    from: `${CONTENT_PATH_VI_ROOT_PAGE_LINK}/site-plan/:projectKey`,
    to: CONTENT_PATH_VI_MODULE_SITE_PLAN_PAGE_LINK,
  },
  // module routers
  {
    from: '/about/:projectKey',
    to: `/:projectKey/${CONTENT_KEY.ABOUT.param}`,
  },
  {
    from: '/location/:projectKey',
    to: `/:projectKey/${CONTENT_KEY.LOCATION.param}`,
  },
  {
    from: '/amenities/:projectKey',
    to: `/:projectKey/${CONTENT_KEY.AMENITIES.param}`,
  },
  {
    from: '/site-plan/:projectKey/:itemKey/:extendable',
    to: `/${CONTENT_KEY.SITEPLAN.param}/:projectKey/:itemKey/:extendable`,
  },
  {
    from: '/site-plan/:projectKey/:itemKey',
    to: `/${CONTENT_KEY.SITEPLAN.param}/:projectKey/:itemKey`,
  },
  { from: '/site-plan/:projectKey', to: `/:projectKey/${CONTENT_KEY.SITEPLAN.param}` },
];
